// extracted by mini-css-extract-plugin
export default {"modalContainer":"OverwriteModal_modalContainer__aWTv+","name":"OverwriteModal_name__C6aIE"};